import {remCalc} from '_themeUtils'

export default {
    '.swiper-pagination': {
        position: 'absolute',
        textAlign: 'center',
        transition: '300ms opacity',
        transform: 'translate3d(0, 0, 0)',
        zIndex: 10,
    },
    '.swiper-pagination.swiper-pagination-hidden': {opacity: 0},
    '.swiper-pagination-disabled > .swiper-pagination, .swiper-pagination.swiper-pagination-disabled': {
        display: 'none !important',
    },
    '.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal':
        {
            bottom: remCalc(8),
            top: 'auto',
            left: '0',
            width: '100%',
        },
    '.swiper-pagination-bullets-dynamic': {overflow: 'hidden', fontSize: '0'},
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet': {
        transform: 'scale(0.33)',
        position: 'relative',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active': {
        transform: 'scale(1)',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main': {
        transform: 'scale(1)',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev': {
        transform: 'scale(0.66)',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev': {
        transform: 'scale(0.33)',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next': {
        transform: 'scale(0.66)',
    },
    '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next': {
        transform: 'scale(0.33)',
    },
    '.swiper-pagination-bullet': {
        width: remCalc(8),
        height: remCalc(8),
        display: 'inline-block',
        borderRadius: '50%',
        background: '#000',
        opacity: '0.2',
    },
    'button.swiper-pagination-bullet': {
        border: 'none',
        margin: '0',
        padding: '0',
        boxShadow: 'none',
        WebkitAppearance: 'none',
        appearance: 'none',
    },
    '.swiper-pagination-clickable .swiper-pagination-bullet': {
        cursor: 'pointer',
    },
    '.swiper-pagination-bullet:only-child': {display: 'none !important'},
    '.swiper-pagination-bullet-active': {
        opacity: '1',
        background: 'black',
    },
    '.swiper-vertical > .swiper-pagination-bullets, .swiper-pagination-vertical.swiper-pagination-bullets': {
        right: remCalc(8),
        left: 'auto',
        top: '50%',
        transform: 'translate3d(0px, -50%, 0)',
    },
    '.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet':
        {
            margin: '6px 0',
            display: 'block',
        },
    '.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic, .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic':
        {
            top: '50%',
            transform: 'translateY(-50%)',
            width: remCalc(8),
        },
    '.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet, .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet':
        {
            display: 'inline-block',
            transition: '200ms transform, 200ms top',
        },
    '.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet':
        {
            margin: '0 4px',
        },
    '.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic, .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic':
        {
            left: '50%',
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
        },
    '.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet':
        {
            transition: '200ms transform, 200ms left',
        },
    '.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet': {
        transition: '200ms transform, 200ms right',
    },
    '.swiper-pagination-fraction': {
        color: 'inherit',
    },
    '.swiper-pagination-progressbar': {
        background: 'rgba(0, 0, 0, 0.25)',
        position: 'absolute',
    },
    '.swiper-pagination-progressbar .swiper-pagination-progressbar-fill': {
        background: 'black',
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        transform: 'scale(0)',
        transformOrigin: 'left top',
    },
    '.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill': {
        transformOrigin: 'right top',
    },
    '.swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal, .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite':
        {
            width: '100%',
            height: remCalc(4),
            left: '0',
            top: '0',
        },
    '.swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical, .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite':
        {
            width: remCalc(4),
            height: '100%',
            left: '0',
            top: '0',
        },
    '.swiper-pagination-lock': {display: 'none'},
}
